import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  setPasswordStatus: IDLE,
  forgotPasswordStatus: IDLE,
  changePasswordStatus: IDLE
};

const passwordSlice = createSlice({
  name: 'password',
  initialState,
  reducers: {
    setPassword: (state) => {
      state.setPasswordStatus = LOADING;
    },
    setPasswordSucceeded: (state) => {
      state.setPasswordStatus = SUCCEEDED;
    },
    setPasswordFailed: (state) => {
      state.setPasswordStatus = FAILED;
    },

    forgotPassword: (state) => {
      state.forgotPasswordStatus = LOADING;
    },
    forgotPasswordSucceeded: (state) => {
      state.forgotPasswordStatus = SUCCEEDED;
    },
    forgotPasswordFailed: (state) => {
      state.forgotPasswordStatus = FAILED;
    },

    changePassword: (state) => {
      state.changePasswordStatus = LOADING;
    },
    changePasswordSucceeded: (state) => {
      state.changePasswordStatus = SUCCEEDED;
    },
    changePasswordFailed: (state) => {
      state.changePasswordStatus = FAILED;
    },

    resetChangePasswordStatus: (state) => {
      state.changePasswordStatus = IDLE;
    }
  }
});

export const {
  setPassword,
  setPasswordSucceeded,
  setPasswordFailed,
  forgotPassword,
  forgotPasswordSucceeded,
  forgotPasswordFailed,
  changePassword,
  changePasswordSucceeded,
  changePasswordFailed,
  resetChangePasswordStatus
} = passwordSlice.actions;

export default passwordSlice.reducer;
